import { pgEnumFromObject } from "../../../functions/pgEnumFromObject";
import { STATIC_RESOURCES } from "@shared/utils/src/core/constants/STATIC_RESOURCES";

/**
 * @group Enums
@summary
<blockquote>PostgreSQL enum for static resources</blockquote>
 * @internal
 */
export const staticResourceEnum = pgEnumFromObject('static_resource', STATIC_RESOURCES);
